<template>
  <div class="annual-graph-tab d-flex flex-column wrap justify-center">
    <div id="chart" class="mt-12">
      <apex-chart :type="options.type" height="500" :options="options" :series="options.series" />
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "AnnualGraphTab",
  components: {
    "apex-chart": VueApexCharts
  },
  data: () => ({
    fill: false,
    gradient: ["red", "orange", "yellow"],
    padding: 8,
    radius: 6,
    labels: ["2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019"],
    value: [
      2925483.24,
      5242530.65,
      5533313.85,
      6045847.02,
      6393128.69,
      6504116.95,
      6556063.94,
      5487257.35
    ],
    width: 2,
    label_size: 6,
    auto_draw: true,
    height: 75,
    options: {
      chart: {
        type: "bar"
      },
      series: [
        {
          name: "Chiffre d'affaire",
          data: [
            2025483,
            5242530,
            5533313,
            6045847,
            6393128,
            6504116,
            6556063,
            5487257
          ]
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "bar"
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val + "%";
          },
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          }
        },
        xaxis: {
          categories: [2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019],
          // position: 'top',
          labels: {
            offsetY: -18
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            }
          },
          tooltip: {
            enabled: true,
            offsetY: -35
          }
        },
        fill: {
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [50, 0, 100, 100]
          }
        },
        yaxis: {
          labels: {
            show: false,
            formatter: function(val) {
              return val + "%";
            }
          }
        },
        title: {
          text: "Chiffre d'affaire Annuel",
          floating: true,
          offsetY: 320,
          align: "center",
          style: {
            color: "#007e84"
          }
        }
      }
    }
  })
};
</script>

<style lang="scss">
.annual-graph-tab {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  svg{
    .apexcharts-series{
      path{
        fill: #007e84;
      }
    }
  }
}
</style>
